
import Vue from 'vue'
import states from '@/helpers/states';
import distanceInWordsStrict from 'date-fns/distance_in_words_strict'

import format from 'date-fns/format'
import deLocale from 'date-fns/locale/de'

export default Vue.extend({
    props: {
        listId: {
            type: String,
            default: ''
        },
        lists: {
            type: Array,
            default: () => ([])
        },
        state: {
            type: Object,
            default: () => ({})
        }
    },
    computed: <any>{
        stateDef() {
            return states[this.state.key]
        },
        classes(): any {
            return {
                'entry-state': true,
                'entry-foreign-state': !this.isOwnState
            }
        },
        isOwnState() {
            return this.state.listId === this.listId
        },
        list() {
            return this.lists.find((l:any) => l.id == this.state.listId)
        },
        distanceDate() {
            return distanceInWordsStrict(new Date, this.state.date, {
                addSuffix: true,
                locale: deLocale
            })
        },
        formattedDate() {
            return format(this.state.date, 'YYYY-MM-DD HH:mm')
        }
    }
})
